import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent, MatTabGroup, MatTab, MatTabLabel } from '@angular/material/tabs';
import { Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import { AppState } from 'src/app/@store/app.reducers';
import { selectDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { CrearActualizarOcupantesAseguradoComponent } from '../../@components/crear-actualizar-ocupantes-asegurado/crear-actualizar-ocupantes-asegurado.component';
import { CrearActualizarOcupanteTerceroComponent } from '../../@components/crear-actualizar-ocupante-tercero/crear-actualizar-ocupante-tercero.component';

@Component({
    selector: 'app-seccion-ocupantes',
    templateUrl: './seccion-ocupantes.component.html',
    styleUrls: ['./seccion-ocupantes.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatTabGroup, MatTab, MatTabLabel, CrearActualizarOcupantesAseguradoComponent, CrearActualizarOcupanteTerceroComponent]
})
export class SeccionOcupantesComponent {

  public tabIndex: number = 0;
  public catTabsOcupantes = [
    { id: 1, nombre: 'Asegurados' },
    { id: 2, nombre: 'Terceros' },
  ];

  public siniestro = null;
  public detalleSiniestro = null;
  public datosLesionados = {
    Asegurados: new MatTableDataSource([]),
    Terceros: new MatTableDataSource([]),
  }
  public listaObservables = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<SeccionOcupantesComponent>,
    private complementoWebService: ComplementoWebService,
    private procesosComunesService: ProcesosComunesComplementoService,
    private store: Store<AppState>,

    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.obtenerReduxState();
  }

  ngOnDestroy(): void {
    this.listaObservables.unsubscribe();
  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleSiniestro]) => {
      this.siniestro = siniestro;
      this.detalleSiniestro = { ...detalleSiniestro };
      this.consultarLesionadosGeneral(siniestro);
    });
    this.listaObservables.add(subsComplemento);
  }

  closeDialog(opcion: string) {
    if (opcion == 'Cancelar') this.dialogRef.close();
    if (opcion == 'Aceptar') this.dialogRef.close();
  }

  onTabChange(event: MatTabChangeEvent) {
    this.tabIndex = Number(event.index + 1);
    this.consultarLesionadosGeneral(this.siniestro);
  }

  consultarLesionadosGeneral(siniestro: string) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(siniestro);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaLesionadosGeneral(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado.Asegurado.length || value.Resultado.Tercero.length) {
          this.datosLesionados.Asegurados = new MatTableDataSource(value.Resultado.Asegurado);
          this.datosLesionados.Terceros = new MatTableDataSource(value.Resultado.Tercero);
        } else {
          // this.procesosComunesService.alertaGeneralComplemento('Aviso', `No se encontró ningun lesionado`, 'info', false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de los lesionados.' }));
      },
    })
  }
}
